import React, { useState } from "react";

import { useLocalStorage } from 'utils/storage';

import packageJson from "../../../../../package.json";

const Debug = () => {
    const today = new Date().toLocaleDateString("en-CA");
    const [selectedDate] = useLocalStorage('selectedDate');
    const [onDateSet] = useLocalStorage('onDateSet');

    const [isMobile] = useState(window.innerWidth < 768);
    const [copied, setCopied] = useState(false);

    const sections = {
        app: {
            version: packageJson.version,
        },
        device: {
            width: window.screen.width,
            height: window.screen.height,
            isMobile: isMobile,
        },
        values: {
            today: today,
            selectedDate: selectedDate,
            onDateSet: onDateSet,
        },
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(JSON.stringify(sections, null, 2));
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (e) {
            console.error('Copy failed', e);
        }
    };

    return (
        <>
            <div className="mt-4">
                <div className="mb-3">
                    <table className="table table-sm align-middle">
                        <tbody>
                            {Object.entries(sections).map(([sectionName, sectionValues]) => (
                                <React.Fragment key={sectionName}>
                                    <tr>
                                        <td colSpan={2}>
                                            <strong>{sectionName}</strong>
                                        </td>
                                    </tr>
                                    {Object.entries(sectionValues).map(([key, value]) => (
                                        <tr key={key}>
                                            <td>
                                                <code className="text-muted">{key}</code>
                                            </td>
                                            <td>
                                                <code className="text-muted">{String(value)}</code>
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="mb-3 d-flex gap-2">
                    <button
                        className="btn btn-warning"
                        onClick={() => window.location.reload()}
                    >
                        Reload App
                    </button>

                    <button
                        className="btn btn-secondary"
                        onClick={handleCopy}
                    >
                        {copied ? 'Copied!' : 'Copy JSON'}
                    </button>
                </div>
            </div>
        </>
    );
};

export default Debug;